function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnGnbMy = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1528 -24)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "\\uD0C0\\uC6D0 33",
  cx: 16,
  cy: 16,
  r: 16,
  transform: "translate(1528 24)",
  style: {
    fill: "#575b6b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.45 6.05a3.8 3.8 0 1 1 3.8 3.8 3.8 3.8 0 0 1-3.8-3.8zm6.2 5h-4.8a4.606 4.606 0 0 0-4.6 4.6 2.2 2.2 0 0 0 2.2 2.2h9.6a2.2 2.2 0 0 0 2.2-2.2 4.606 4.606 0 0 0-4.6-4.6z",
  transform: "translate(1533.75 29.951)",
  style: {
    fill: "#fff"
  }
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnGnbMy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "52363d3e0ec534da7ef521871a6345c3.svg";